import { atom } from "jotai";

const userTeammatesAtom = atom<any | string>("");
userTeammatesAtom.debugLabel = "User Teammates";

export { userTeammatesAtom };
